import styled from 'styled-components';

export const hexToRgba = (hex, alpha) => {
  const value = hex.replace('#', '');
  const r = parseInt(value.substring(0, 2), 16);
  const g = parseInt(value.substring(2, 4), 16);
  const b = parseInt(value.substring(4, 6), 16);
  return `rgba(${r}, ${g}, ${b}, ${alpha})`;
};

export const TitleWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;

export const TitleIconWrap = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background: ${({ theme }) => hexToRgba(theme.colors.warning, 0.15)};
  color: ${({ theme }) => theme.colors.warning};
  flex-shrink: 0;
`;

export const TitleText = styled.span`
  color: ${({ theme }) => theme.colors.text};
`;

export const MessageWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 14px;
`;

export const MainText = styled.span`
  color: ${({ theme }) => theme.colors.textSecondary};
  line-height: 1.5;
  font-size: 14px;
`;

export const ProgramName = styled.strong`
  color: ${({ theme }) => theme.colors.text};
`;

export const ResetCard = styled.div`
  display: flex;
  gap: 12px;
  padding: 14px 16px;
  border-radius: 10px;
  cursor: pointer;
  user-select: none;
  background: ${({ theme, $active }) =>
    $active ? hexToRgba(theme.colors.danger, 0.08) : theme.colors.background};
  border: 5px solid
    ${({ theme, $active }) =>
      $active
        ? hexToRgba(theme.colors.danger, 0.35)
        : theme.colors.extralightGray};
  transition:
    background 0.15s ease,
    border-color 0.15s ease;
`;

export const ResetIconWrap = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  border-radius: 50%;
  background: ${({ theme }) => hexToRgba(theme.colors.danger, 0.12)};
  color: ${({ theme }) => theme.colors.danger};
  flex-shrink: 0;
  margin-top: 20px;
`;

export const ResetTextCol = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  flex: 1;
`;

export const ResetTitle = styled.span`
  margin-bottom: 2px;
  padding-left: 36px;
  font-weight: 600;
  font-size: 14px;
  color: ${({ theme }) => theme.colors.text};
`;

export const ResetDescription = styled.span`
  color: ${({ theme }) => theme.colors.textSecondary};
  font-size: 13px;
  line-height: 1.5;
  padding-left: 36px;
  margin-top: -6px;
`;

export const ResetDescriptionStrong = styled.strong`
  color: ${({ theme }) => theme.colors.danger};
`;

export const ConfirmText = styled.span`
  color: ${({ theme }) => theme.colors.textSecondary};
  font-size: 14px;
`;
